import axios from 'axios';
import Api from './Api';

class TruckScheduleTruckTypeLinkedTruckTypeApi extends Api {
  constructor() {
    super('truck-schedules/truck-type-linked-truck-types', 'truck-schedules/truck-type-linked-truck-types');
  }

  async save(method, data) {
    try {
      const response = await axios({ method, url: `/${this.endpoint}`, data });
      if (!response.data) throw new Error('Unable to save truck type link');
      return response.data;
    } catch (error) {
      if (error.response && typeof error.response.data === 'string') {
        throw new Error(error.response.data);
      }
      throw error;
    }
  }

  async store(data) {
    return this.save('post', data);
  }

  async update(data) {
    return this.save('put', data);
  }

  async delete(id) {
    try {
      const response = await axios.delete(`/${this.endpoint}/${id}`);
      if (!response.data) throw new Error('Unable to delete truck type link');
      return response.data;
    } catch (error) {
      if (error.response && typeof error.response.data === 'string') {
        throw new Error(error.response.data);
      }
      throw error;
    }
  }
}

export default new TruckScheduleTruckTypeLinkedTruckTypeApi();
